import { useContext, useEffect } from "react"
import { useField } from "formik"
import { FormContext } from "../../../context/formContext"
import { classNames } from "primereact/utils"

//Assessment modules
import AssessmentBlock from "../../Assessments/AssessmentBlock/AssessmentBlock"

//SOAR Forms components
import BlockActionBtns from "../../Form/BlockActionBtns"

import styles from "../../../styles/Form.module.css"

export default function Assessments({ block }) {
  const globalFormCtx = useContext(FormContext)
  const blockName = block?.block_name || "session__assessment"
  const readOnlyMode = globalFormCtx.blocksSaved[blockName]
  const [field, , helpers] = useField("assessments")
  const form = useContext(FormContext)

  useEffect(() => {
    const registerField = {
      field_name: field.name
    }

    // Register field as loading in FormContext
    form && form.registerLoadingField(registerField)

    if (!field.value && block?.configuration?.rules?.assessments) {
      const assessments = block?.configuration?.rules?.assessments.map(
        (assessment) => {
          return {
            assessment_id: assessment.assessment_id,
            required: assessment.required,
          }
        }
      )

      helpers.setValue(JSON.stringify(assessments))
    }

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(registerField)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const renderActionButtons = (style) => {
    return (
      <div className={style}>
        <BlockActionBtns block={block.block_name} />
      </div>
    )
  }

  return (
    <div key={block.block_name} className={classNames(styles.block, styles.assessmentsBlock)}>
      <AssessmentBlock
        assessmentConfig={field.value ? JSON.parse(field.value) : []}
        onSubmitAssessments={(assessments) => {
          helpers.setValue(JSON.stringify(assessments))
        }}
        readOnly={readOnlyMode}
        sessionTemplateId={globalFormCtx.idTemplate}
        stageCompletedAssessmentUpdates={true}
        actionButtons={renderActionButtons(styles.blockActions)}
      />
      
      {renderActionButtons(styles.blockActions)}
    </div>
  )
}
